module.exports = __webpack_public_path__ + "static/media/mobile-menu-icon.45267307.svg";